export const ORDER_ACTIONS = {
  ADD_ORDER_DETAIL_DEFINITIONS: 'ADD_ORDER_DETAIL_DEFINITIONS',
  ADD_ORDERS: 'ADD_ORDERS',
  ADD_ORDER: 'ADD_ORDER',
  CHANGE_SELECTED_ORDER: 'CHANGE_SELECTED_ORDER',
  CHANGE_SELECTED_ORDER_DETAILS: 'CHANGE_SELECTED_ORDER_DETAILS',
  UPDATE_ORDER: 'UPDATE_ORDER',
  UPDATE_ORDER_DETAILS: 'UPDATE_ORDER_DETAILS',
  UPDATE_ORDER_DETAIL: 'UPDATE_ORDER_DETAIL',
  DELETE_ORDER: 'DELETE_ORDER',
  CLEAR_ORDERS: 'CLEAR_ORDERS'
};
